import { useCallback } from 'react';
import api from '../../../services/api';

// HR Analytics — read-mostly hook for Task 16 (Genel Bakış). getSettings/
// updateSettings are already live on the backend (Task 14/15) and included
// here for parity, even though the Overview page only calls getCatalog/
// getReadiness today — later HA screens (settings UI) reuse this hook as-is.
//
// getMetrics — Task 13 (ana dashboard'un SmartStatsRow'u) eklendi. params, HaMetricsController.
// GetMetrics'in query string sözleşmesiyle BİREBİR aynı adları taşır ({ codes, scope, grain,
// from, to }) — axios bunu ?codes=...&scope=...&grain=... olarak serileştirir. Yeni bir client
// AÇILMADI, mevcut hook genişletildi (CLAUDE.md: "API calls go in src/services/", bu hook zaten
// o katmanın HA'ya özgü ince kabuğu).
export const useHrAnalyticsApi = () => {
  const getCatalog = useCallback(() => api.get('/v1/ha/catalog'), []);
  const getReadiness = useCallback(() => api.get('/v1/ha/readiness'), []);
  // L2 kural kataloğu — eskiden bu dosyada ELLE aynalanıyordu (takip listesi md. 15).
  // Elle tutulan liste, listeye yeni bir kural eklendiğinde tam gerektiği anda eksik kalır.
  const getRules = useCallback(() => api.get('/v1/ha/rules'), []);
  const getSettings = useCallback(() => api.get('/v1/ha/settings'), []);
  const updateSettings = useCallback((body) => api.put('/v1/ha/settings', body), []);
  const getMetrics = useCallback((params) => api.get('/v1/ha/metrics', { params }), []);
  // İşe Alım Raporu — XLSX. Sorgu sözleşmesi getMetrics ile BİREBİR aynı ({ codes, scope,
  // grain, from, to }); backend de aynı okuma gövdesini çağırır, yani dosyadaki hücreler
  // ekrandakilerle AYNI bastırma kararından geçer (bkz. HaMetricsExporter sınıf özeti).
  const exportMetrics = useCallback(
    (params) => api.get('/v1/ha/metrics/export', { params, responseType: 'blob' }), []);
  // Task 14 — Karşılaştırma sayfası (funnel plot). HaMetricsController.GetFunnel'in query
  // string sözleşmesiyle BİREBİR aynı adları taşır ({ code, scope, grain, period }).
  const getFunnel = useCallback((params) => api.get('/v1/ha/funnel', { params }), []);
  // Task 15 — Devir & Kohort sayfası (Kaplan-Meier). HaMetricsController.GetSurvival'ın query
  // string sözleşmesiyle BİREBİR aynı adları taşır ({ scope, scopeId }) — `grain` YOK (uç
  // grain parametresi almıyor, doğrudan HaTenureAxis.Grain filtreliyor, bkz. task-15 brief).
  const getSurvival = useCallback((params) => api.get('/v1/ha/survival', { params }), []);

  // Dağılım paneli — KIRILIM ÇUBUĞUNA TIKLANINCA çağrılır, sayfa yüklenişinde değil.
  // Kapsam başına tek istek; dönem kapalı olduğu için sonuç değişmez.
  const getDistribution = useCallback((params) => api.get('/v1/ha/distribution', { params }), []);
  // Task 10 — Erken Uyarılar sayfası. HaAlertsController.GetAll'ın query string
  // sözleşmesiyle BİREBİR aynı adları taşır ({ status, ruleCode, scope, severity, pageNumber,
  // pageSize }); axios bunu ?status=...&pageNumber=...&pageSize=... olarak serileştirir.
  const getAlerts = useCallback((params) => api.get('/v1/ha/alerts', { params }), []);
  // PATCH /v1/ha/alerts/{id} — gövde HaAlertPatchRequest ile BİREBİR aynı şekil ({ status }).
  // Yalnız kullanıcı-tetikli üç hedefi kabul eder (acknowledged | resolved | dismissed) — "open"
  // burada asla geçerli bir hedef DEĞİLDİR (bkz. HaAlertsDataAccess.AllowedTransitions yorumu).
  const patchAlert = useCallback((id, body) => api.patch(`/v1/ha/alerts/${id}`, body), []);

  // §12 yorum katmanı (HaInsightsController). Bu dört servis uzun süre DI'da kayıtlıydı ama
  // hiçbir uçtan erişilemiyordu — "servis yazıldı" ile "özellik teslim edildi" arasındaki fark.
  // Query string adları backend imzalarıyla BİREBİR aynı.
  const getNarrative = useCallback(() => api.get('/v1/ha/narrative'), []);
  const getTextThemes = useCallback(() => api.get('/v1/ha/text-themes'), []);
  // { metricCode, scope } — HaAnomalyService.DetectAsync ile aynı adlar.
  const getAnomalies = useCallback((params) => api.get('/v1/ha/anomalies', { params }), []);
  const getHypotheses = useCallback((alertId) => api.get(`/v1/ha/alerts/${alertId}/hypotheses`), []);
  // Gövde HaHypothesisDecisionRequest ile aynı şekil ({ status }); yalnız accepted|rejected.
  const decideHypothesis = useCallback(
    (id, body) => api.post(`/v1/ha/hypotheses/${id}/decide`, body), []);
  // Spec §9.3 — { code }. Kilitli metrik 200 + state döner, 403 DEĞİL.
  const getModelQuality = useCallback((params) => api.get('/v1/ha/model-quality', { params }), []);

  return {
    getCatalog, getReadiness, getRules, getSettings, updateSettings, getMetrics, exportMetrics,
    getFunnel, getSurvival,
    getDistribution,
    getAlerts, patchAlert,
    getNarrative, getTextThemes, getAnomalies, getHypotheses, decideHypothesis, getModelQuality,
  };
};

// İŞE ALIM (AT) AİLESİ — HaMetricCatalog.cs §6.3'ün sekiz kodu, katalogdaki SIRAYLA.
//
// Bu liste sayfanın hangi metrikleri İSTEDİĞİNİ söyler, hangilerinin AÇIK olduğunu DEĞİL:
// tenant'ın AT (ve qualityOfHire için ayrıca PM) aboneliği yoksa uç o kodu 200 + state
// ("locked_module") ile döner, sayfa da onu kilit gerekçesiyle gösterir. Kod burada elle
// tutuluyor çünkü "İşe Alım Raporu" bir ÜRÜN seçimidir — kataloğu `startsWith('recruiting.')`
// ile süzmek, yarın eklenecek bir recruiting metriğini bu rapora SESSİZCE sokardı.
export const RECRUITING_METRIC_CODES = [
  'recruiting.funnel.conversion',
  'recruiting.timeToFill',
  'recruiting.timeInStage',
  'recruiting.source.effectiveness',
  'recruiting.offerAcceptance.rate',
  'recruiting.sla.breach',
  'recruiting.pipeline.aging',
  'recruiting.qualityOfHire',
  // ATS maliyet kaydından (2026-09-23) — masraf modülünden BESLENMEZ; birim = para.
  'recruiting.costPerHire',
];

// AYNA KALDIRILDI (takip listesi md. 15). Kural kataloğu artık `GET /v1/ha/rules` ucundan
// gelir; burada bir yedek liste TUTULMAZ — yedek liste, tam da çözülmek istenen "iki kaynak"
// sorununu geri getirirdi ve eskidiğinde kimse fark etmezdi. Uç cevap vermezse ekran kural
// bölümünü boş gösterir; bu, yanlış bir listeyi doğru sanmaktan iyidir.

// Kural kodu → çeviri anahtarı. Kural KATALOĞU artık uçtan geliyor ama bu harita hâlâ ELLE
// tutuluyor ve tam da bu yüzden sürükleniyordu: `absence.risingTrend` katalogda VARDI, çevirisi
// beş dilde VARDI, ama bu haritada YOKTU — ayarlar ekranı o kuralı ham çeviri anahtarı olarak
// gösteriyordu. Eski ayna testi `HA_RULE_CATALOG`'u koruyordu, bu haritayı KORUMUYORDU.
// haRuleCatalog.contract.test.js artık bunu paylaşılan sözleşmeye karşı pinliyor.
export const RULE_NAME_KEY = {
  'contract.expiring': 'contractExpiring',
  'probation.reviewOverdue': 'probationReviewOverdue',
  'document.missing': 'documentMissing',
  'training.mandatoryOverdue': 'trainingMandatoryOverdue',
  'certification.expiring': 'certificationExpiring',
  'workload.weekly55': 'weeklyHours',
  'workload.restPeriod': 'restPeriod',
  'workload.nightConsecutive': 'nightConsecutive',
  'leave.longAbsence': 'longAbsence',
  'absence.risingTrend': 'risingTrend',
  'talent.successionGap': 'successionGap',
  'onboarding.earlyLeaveRisk': 'earlyLeaveRisk',
};

// HaMetricRegistry.ModulesSatisfied'ın (backend) BİREBİR aynı CNF değerlendirmesi: dış dizi VE,
// iç dizi VEYA. `hasModule` zaten AuthContext'in `user.modules` listesine bakıyor (bkz. o
// dosyanın "Module AVAILABILITY in the active tenant" yorumu) — ikinci bir "tenant'ın modülleri"
// kaynağı İCAT EDİLMEDİ.
export function isRuleModuleSatisfied(requiredModules, hasModule) {
  return requiredModules.every((orGroup) => orGroup.some((code) => hasModule(code)));
}

// Kilitli bir kuralın GEREKÇESİ için: sağlanmayan OR-gruplarının listesi. HrAnalyticsOverviewPage.js
// (metrik kataloğu) ile AYNI sunum deseni — gruplar ' / ' ile, gruplar arası ' + ' ile birleştirilir.
export function missingModuleGroups(requiredModules, hasModule) {
  return requiredModules.filter((orGroup) => !orGroup.some((code) => hasModule(code)));
}

// Kapsam seçicisinin varsayılanı HaSettings.PrimaryScopeOrder'dan gelir — SABİT KODLANMAZ
// (task-14 brief). PrimaryScopeOrder tüm HA ekranları için ORTAK, genel bir tercih sırasıdır;
// ama her metriğin desteklediği kapsamlar (HaCatalogItemResponse.SupportedScopes) farklı
// olabilir — turnover.byScope.funnel'in ör. Tenant hücresi hiç YOK (bkz. HaMetricCatalog.cs
// "NoTenant"). Bu yüzden düz `primaryScopeOrder[0]` yeterli değildir: PrimaryScopeOrder'ı
// GEZİP bu metriğin GERÇEKTEN desteklediği ilk tercihi buluruz. Hiçbiri eşleşmezse (örn.
// kullanıcı tüm sırayı bu metrik için anlamsız bir kombinasyona ayarladıysa) desteklenen
// listenin ilkine düşülür — boş bir seçiciyle kalmamak için savunmacı bir son çare.
export function resolveDefaultScope(primaryScopeOrder, supportedScopes) {
  const order = Array.isArray(primaryScopeOrder) ? primaryScopeOrder : [];
  const supported = Array.isArray(supportedScopes) ? supportedScopes : [];
  const fromOrder = order.find((s) => supported.includes(s));
  if (fromOrder) return fromOrder;
  return supported.length > 0 ? supported[0] : null;
}
